module.exports = __webpack_public_path__ + "static/media/answer4.97ba7746.svg";